import React from "react"
import clsx from "clsx"

import Button from "@components/ui/Button/Button"

import styles from "./TruncatedText.module.sass"

export const TruncatedText: React.FC<{
  children?: React.ReactNode
  truncated?: boolean
  maxLines?: number
  className?: string
  onReadMoreClick?: React.MouseEventHandler
}> = ({ children = "", maxLines, className, truncated, onReadMoreClick }) => {
  const [isOpen, setOpen] = React.useState(false)

  const isTruncated = truncated ?? !isOpen

  const [isTextOverflowed, setIsTextOverflowed] = React.useState(false)

  const contentNodeRef = React.useRef<HTMLDivElement>(null)

  React.useLayoutEffect(() => {
    const node = contentNodeRef.current

    if (node == null || !isTruncated) return

    setIsTextOverflowed(node.offsetHeight < node.scrollHeight)
  }, [children, isTruncated, maxLines])

  return (
    <>
      <div
        ref={contentNodeRef}
        className={clsx(
          styles.root,
          { [styles.clamp]: isTruncated },
          className
        )}
        style={isTruncated ? { WebkitLineClamp: maxLines } : undefined}
      >
        {children}
      </div>

      {isTextOverflowed && (
        <Button
          className={styles.readMore}
          onClick={onReadMoreClick ?? (() => setOpen((prev) => !prev))}
          noPadding
          variant="slim"
          size="tiny"
        >
          {isTruncated ? "Read More" : "Read Less"}
        </Button>
      )}
    </>
  )
}
export default TruncatedText
